export const domainsConstants = {
  GET_DOMAINS_REQUEST: "GET_DOMAINS_REQUEST",
  GET_DOMAINS_SUCCESS: "GET_DOMAINS_SUCCESS",
  GET_DOMAINS_FAILURE: "GET_DOMAINS_FAILURE",
  GET_DOMAINS_RESET: "GET_DOMAINS_RESET",

  VIEW_DOMAIN_REQUEST: "VIEW_DOMAIN_REQUEST",
  VIEW_DOMAIN_SUCCESS: "VIEW_DOMAIN_SUCCESS",
  VIEW_DOMAIN_FAILURE: "VIEW_DOMAIN_FAILURE",
  VIEW_DOMAIN_RESET: "VIEW_DOMAIN_RESET",

  ADD_DOMAIN_REQUEST: "ADD_DOMAIN_REQUEST",
  ADD_DOMAIN_SUCCESS: "ADD_DOMAIN_SUCCESS",
  ADD_DOMAIN_FAILURE: "ADD_DOMAIN_FAILURE",
  ADD_DOMAIN_RESET: "ADD_DOMAIN_RESET",

  EDIT_DOMAIN_REQUEST: "EDIT_DOMAIN_REQUEST",
  EDIT_DOMAIN_SUCCESS: "EDIT_DOMAIN_SUCCESS",
  EDIT_DOMAIN_FAILURE: "EDIT_DOMAIN_FAILURE",
};
